import { hasOwnProperty } from "@glideapps/ts-necessities";
import { logError } from "./debug-print";

export type ComponentIndexes = readonly [number] | readonly [number, number];

// ##componentPositionIDs:
// These are used to encode the component's position in a screen into a
// string, because that's the easiest way to pass them to a highlight
// renderer, which needs to be able to communicate its position.  We can
// probably get rid of this once we're on the new component model.
export function makeComponentPositionID(screenName: string, indexes: ComponentIndexes): string {
    return JSON.stringify({ screenName, indexes });
}

export function decomposeComponentPositionID(
    componentID: string
): { screenName: string; indexes: ComponentIndexes } | undefined {
    try {
        const parsed = JSON.parse(componentID);
        if (parsed === undefined) return undefined;
        if (!hasOwnProperty(parsed, "screenName") || !hasOwnProperty(parsed, "indexes")) return undefined;
        return parsed as any;
    } catch {
        logError("Could not parse component ID", componentID);
        return undefined;
    }
}
